import { useEffect, useState } from 'react';
import { ExportToCsv } from '../../csv/ExportToCsv';
import { GetPeriodDisplay } from '../../dash/DashDateSelection';
import getExternalSearchQueryParams from '../client/GetExternalSearchQueryParams';
import { P2GLink } from '@parcel2go/core-ui';
import SidePanelSection, { SidePanelSections } from '../../../../../components/sidepanel-section';
import { P2GText } from '@parcel2go/core-ui';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import { P2GSidePanel } from '~/components/sidepanel';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

export interface SmartSendItemProps {
  period: string;
  selected: string;
  search?: string;
}

export default function CsvExport(props: SmartSendItemProps) {
  const { exportItems } = useSmartSendApi();
  const [csv, setCsv] = useState<{ fields: string[]; data: string[][] }>(null);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useEffect(() => {
    if (open) {
      exportItems(getExternalSearchQueryParams(props.period, props.selected), props.search).then((r) => {
        setCsv({
          data: r.result.Records,
          fields: r.result.Header
        });
      });
    } else {
      setCsv(null);
    }
  }, [open]);

  useEffect(() => {
    setOpen(false);
  }, [props.period, props.selected, props.search]);

  return (
    <>
      <P2GLink onClick={() => setOpen(true)}>{t('EXPORT_CSV_LINK', { defaultValue: 'Export CSV' })}</P2GLink>
      <P2GSidePanel
        open={open}
        onClose={() => setOpen(false)}
        anchor="right"
        title={t('EXPORT_CSV_TITLE', { defaultValue: 'Export CSV' })}
      >
        <SidePanelSections>
          <SidePanelSection>
            <P2GText component="p">
              {t('EXPORT_CSV_INTRO_TEXT', {
                defaultValue:
                  'This export includes all items from the selected period and filter. The file will be downloaded as a CSV below.'
              })}
            </P2GText>
          </SidePanelSection>

          {csv && (
            <ExportToCsv
              fileName={GetPeriodDisplay(props.period)}
              mode="auto"
              data={() => csv}
              headers={() => csv.fields}
            />
          )}
        </SidePanelSections>
      </P2GSidePanel>
    </>
  );
}
